import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-ambulance-document',
    templateUrl: './ambulance-document.component.html',
    styleUrls: ['./ambulance-document.component.scss'],
    standalone: false
})
export class AmbulanceDocumentComponent implements OnInit {
  data: any;
  title: any;
  message: any;

  constructor(
    private bsModal: BsModalRef,
    private route: Router
  ) { }

  ngOnInit() {
    this.data = this['data'];
    this.title = "Document Upload";
    this.message = this.data.notification.body
  }

  hide() {
    // this.route.navigate(['ambulance-management/er-connect']);
    this.bsModal.hide()
  }

}
